import request from '../request'

export function listProductionOrder(params) {
  return request.get('/production/order/list', { params: params || {} })
}

export function getProductionOrder(id) {
  return request.get('/production/order/info/' + id)
}

export function saveProductionOrder(data) {
  return request.post('/production/order/save', data || {})
}

export function updateProductionOrder(data) {
  return request.post('/production/order/update', data || {})
}

export function saveOrUpdateProductionOrder(data) {
  if (data && data.productionOrderId) return updateProductionOrder(data)
  return saveProductionOrder(data)
}

export function deleteProductionOrder(productionOrderId) {
  return request.post('/production/order/delete', { productionOrderId, id: productionOrderId })
}

export function releaseProductionOrder(productionOrderId) {
  return request.post('/production/order/release', { productionOrderId, id: productionOrderId })
}

export function completeProductionOrder(productionOrderId) {
  return request.post('/production/order/finish', { productionOrderId, id: productionOrderId })
}

export function closeProductionOrder(productionOrderId) {
  return request.post('/production/order/close', { productionOrderId, id: productionOrderId })
}

export function refreshProductionOrderRouting(productionOrderId) {
  return request.post('/production/order/refreshRouting', { productionOrderId, id: productionOrderId })
}

export function pushFromSales(data) {
  return request.post('/production/order/pushFromSales', data || {})
}

export function listLinesForMergeProduction(query) {
  return request.post('/production/order/linesForMergeProduction', {
    currentPage: query.pageIndex || query.currentPage || 1,
    pageSize: query.pageSize || 50,
    materialId: query.materialId,
    materialCode: query.materialCode,
    salesOrderCode: query.salesOrderCode,
    customerName: query.customerName,
    salesOrderIds: query.salesOrderIds
  })
}

export function getLinesForProduction(salesOrderId, excludeProductionOrderId) {
  return request.get('/sale/salesOrder/linesForProduction/' + salesOrderId, {
    params: { excludeProductionOrderId: excludeProductionOrderId || undefined }
  })
}

export function listMaterialBomVersion(materialId) {
  return request.get('/base/materialBom/versionList', { params: { materialId } })
}

export function listProductionSchedule(params) {
  return request.get('/production/schedule/list', { params: params || {} })
}

export function saveProductionSchedule(lines) {
  return request.post('/production/schedule/save', { lines: lines || [] })
}

export function getScheduleGantt(query) {
  return request.post('/production/schedule/gantt', query || {})
}

export function getScheduleCenterLoad(query) {
  return request.post('/production/schedule/centerLoad', query || {})
}

export function autoProductionSchedule(data) {
  return request.post('/production/schedule/autoSchedule', data || {})
}

export function optimizeProductionSchedule(data) {
  return request.post('/production/schedule/optimizeSchedule', data || {})
}

export function moveScheduleTask(data) {
  return request.post('/production/schedule/moveTask', data || {})
}
